import React, { useEffect, useState } from "react";

import { generateRandomNumber, useTranslation } from "utils";

import { Anchor, LazyLoadImage, Svg } from "components";

export type FarmerType = "dairy" | "default";

interface TestimonialScreenProps {
  farmerType: FarmerType;
}

interface Testimonial {
  name: string;
  img: string;
  quote: string;
  source: string;
}

export const TestimonialScreen = ({ farmerType }: TestimonialScreenProps) => {
  const { t } = useTranslation("intro");
  const [testimonial, setTestimonial] = useState<Testimonial | undefined>();

  const getTestimonials = (): Testimonial[] => t(`testimonialsArray.${farmerType}`, { returnObjects: true }) as Testimonial[];

  const testimonials = getTestimonials();

  useEffect(() => {
    if (testimonial) return;
    if (!Array.isArray(testimonials)) return;
    const randomNumber = generateRandomNumber(0, testimonials.length);
    const randomTestimonial = testimonials[randomNumber];
    setTestimonial(randomTestimonial);
  }, [testimonials, testimonial]);

  return (
    <>
      {testimonial && (
        <div className="testimonials-screen">
          {/* this annoying line of code ensures that the image is loaded even if the translation key is incorrect */}
          <LazyLoadImage alt={testimonial.name} src={`/images/intro/testimonials/${testimonial.img.toLowerCase().replace(" ", "-").replace(".jpg", "")}.jpg`} />
          <div className="container">
            <Anchor href="https://www.klim.eco/en/farmers/platform" target="_self">
              <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
            </Anchor>
            <div className="quote-box margin-top-200">
              <Svg svgName="intro/quote" width={48} height={48} />
              <h3>{testimonial.quote}</h3>
              <p className="paragraph-m">{testimonial.source}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
